import Select, {
    ActionMeta,
    components,
    SelectComponentsConfig,
    OnChangeValue,
    OptionsOrGroups,
    GroupBase,
} from 'react-select';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { SelectCaretDownIcon, ClearIndicatorIcon } from './icons/icons';
import { OptionTypeBase } from '../../definitions/interfaces/reactSelectOptions';

interface SelectProps<T extends OptionTypeBase, IsMulti extends boolean> {
    name: string;
    value?: OnChangeValue<T, IsMulti>;
    onChange: (
        value: OnChangeValue<T, IsMulti>,
        actionMeta: ActionMeta<T>
    ) => void;
    options: OptionsOrGroups<any, GroupBase<T>>;
    isMulti?: boolean;
    classes?: string;
    testId?: string;
    isClearable?: boolean;
    placeholder?: string;
    hideSelectedOptions?: boolean;
    components?: SelectComponentsConfig<T, IsMulti, GroupBase<T>> | undefined;
    isDisabled?: boolean;
}

export const DropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <SelectCaretDownIcon />
        </components.DropdownIndicator>
    );
};

export const ClearIndicator = (props: any) => {
    return (
        <components.ClearIndicator {...props}>
            <ClearIndicatorIcon />
        </components.ClearIndicator>
    );
};

export const AppSelect: React.FC<SelectProps<any, boolean>> = (
    props: SelectProps<any, boolean>
) => {
    const localization = useSelector((state: RootState) => state.localization);
    const customStyles = {
        singleValue: (provided: any, state: any) => {
            if (
                state.data.label ===
                localization.localizationStrings.susy.shared.Select
                    .SelectPlaceholder
            ) {
                const color = '#a6adc6';
                return { ...provided, color };
            }
        },
    };
    const classNames = `susy-select ${props.classes ?? ''}`;
    return (
        <div data-testid={props.testId}>
            <Select
                isClearable={props.isClearable}
                isMulti={props.isMulti}
                isDisabled={props.isDisabled}
                name={props.name}
                className={classNames}
                classNamePrefix='select'
                styles={customStyles}
                value={props.value}
                onChange={props.onChange}
                options={props.options}
                components={{
                    ...props.components,
                    DropdownIndicator,
                    ClearIndicator,
                    IndicatorSeparator: null,
                }}
                hideSelectedOptions={props.hideSelectedOptions}
                placeholder={props.placeholder}
            />
        </div>
    );
};
